module.exports = "pegasus_template/assets/responsive-card.png";